import { useEffect, useMemo, useState, useDeferredValue } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ChevronLeft, Loader2, Search, Phone, MapPin, Store, Clock } from "lucide-react";
import { smartMatch } from "../../utils/arabicSearch";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const fmt = (n) => Number(n || 0).toLocaleString("en-US", { maximumFractionDigits: 0 });
export const fmtDate = (iso) => {
  if (!iso) return "ما قطع بعد";
  try { return new Date(iso).toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric", timeZone: "Asia/Baghdad" }); }
  catch { return "—"; }
};
export const debtStyle = (d) => (d > 0 ? { color: "#DC2626", bg: "#FEE2E2", label: "دين" }
  : d < 0 ? { color: "#2563EB", bg: "#DBEAFE", label: "له عدنا" } : { color: "#16A34A", bg: "#DCFCE7", label: "ما عليه" });
const digits = (s) => String(s || "").replace(/\D/g, "");
export const matchCustomer = (c, q) => {
  const t = q.trim();
  if (!t) return true;
  const d = digits(t);
  if (d.length >= 3 && digits(c.phone).includes(d)) return true;
  return smartMatch(`${c.full_name} ${c.market_name} ${c.address}`, t);
};

export const CustomerRow = ({ c, onClick, extra }) => {
  const ds = debtStyle(c.debt);
  return (
    <button type="button" onClick={onClick} disabled={!onClick} data-testid={`cust-row-${c.id}`}
      className="w-full text-right bg-white rounded-2xl p-3 shadow-sm border border-slate-100 flex items-start gap-3">
      <div className="flex-1 min-w-0 space-y-0.5">
        <p className="font-black text-[#0B1E4A]">{c.full_name}</p>
        {c.market_name && <p className="text-[11px] text-slate-600 flex items-center gap-1"><Store className="w-3 h-3" />{c.market_name}</p>}
        {c.address && <p className="text-[11px] text-slate-500 flex items-center gap-1"><MapPin className="w-3 h-3" />{c.address}</p>}
        <p className="text-[11px] text-slate-500 flex items-center gap-1"><Phone className="w-3 h-3" /><span dir="ltr">{c.phone}</span></p>
        <p className="text-[11px] text-slate-500 flex items-center gap-1"><Clock className="w-3 h-3" />آخر فاتورة: <b>{fmtDate(c.last_invoice_at)}</b></p>
        {extra}
      </div>
      <div className="rounded-xl px-2.5 py-2 text-center shrink-0" style={{ background: ds.bg }} data-testid={`cust-debt-${c.id}`}>
        <p className="text-[9px] font-bold" style={{ color: ds.color }}>{ds.label}</p>
        <p className="font-black text-sm" style={{ color: ds.color }} dir="ltr">{fmt(Math.abs(c.debt))}</p>
      </div>
    </button>
  );
};

const MandoobCustomers = ({ onBack }) => {
  const [rows, setRows] = useState(null);
  const [q, setQ] = useState("");
  const dq = useDeferredValue(q);
  useEffect(() => {
    axios.get(`${API}/mandoob/customers`).then(({ data }) => setRows(data)).catch(() => toast.error("فشل تحميل الزبائن"));
  }, []);
  const list = useMemo(() => (rows || []).filter((c) => matchCustomer(c, dq)), [rows, dq]);
  return (
    <div className="-mx-3 -my-4 px-4 py-6 min-h-[calc(100vh-60px)] space-y-3" dir="rtl" data-testid="mandoob-customers"
      style={{ background: "radial-gradient(circle at top, #1E3A8A 0%, #0B1E4A 55%, #050F2C 100%)" }}>
      <button onClick={onBack} data-testid="mandoob-customers-back" className="text-white text-sm font-bold flex items-center gap-1">
        <ChevronLeft className="w-4 h-4 rotate-180" /> الرئيسية
      </button>
      <h2 className="text-white font-black text-2xl">الزبائن <span className="text-sm text-blue-200">({list.length})</span></h2>
      <div className="relative">
        <Search className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="ابحث بالاسم، الماركت، العنوان أو الرقم..."
          data-testid="mandoob-customers-search" className="w-full pr-9 pl-3 py-3 rounded-2xl text-sm outline-none" />
      </div>
      {!rows ? <Loader2 className="w-6 h-6 animate-spin text-white mx-auto" /> :
        list.length === 0 ? <p className="text-center text-blue-200 py-8">لا يوجد زبائن</p> :
          <div className="space-y-2">{list.map((c) => <CustomerRow key={c.id} c={c} />)}</div>}
    </div>
  );
};

export default MandoobCustomers;
